/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Extra_MarginInputs */

const en_setup_extra_margin = /** @type {(inputs: Setup_Extra_MarginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra margin`)
};

/**
* | output |
* | --- |
* | "Extra margin" |
*
* @param {Setup_Extra_MarginInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_extra_margin = /** @type {((inputs?: Setup_Extra_MarginInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Extra_MarginInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_extra_margin(inputs)
});